'use client'

import { analyticsConsentSchema } from '@mentora/data-access/analytics-events'
import { AnalyticsIdentity as SharedAnalyticsIdentity } from '@mentora/feature-components/analytics'
import { saveAnalyticsConsentAction } from '@/app/actions/analytics-consent'
import { authClient } from '@/lib/auth-client'
import { STOREFRONT } from '@/lib/storefront'

const actions = { saveConsent: saveAnalyticsConsentAction }

export function AnalyticsIdentity() {
  // Same session atom as the header's user menu: no extra request.
  const { data: session } = authClient.useSession()
  const raw = session?.user as { id: string, role?: string | null, analyticsConsent?: unknown } | undefined
  const stored = analyticsConsentSchema.safeParse(raw?.analyticsConsent)
  const user = raw
    ? { id: raw.id, role: raw.role ?? null, analyticsConsent: stored.success ? stored.data : null }
    : null
  return <SharedAnalyticsIdentity storefront={STOREFRONT} user={user} actions={actions} />
}
